import React, { useContext, useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { redirect } from "react-router-dom";
import { GlobalState } from "../GlobalState";

import NotFound404 from "../pages/notFound404";
import Events from "../pages/Events";
import LoginUser from "./LoginUser";
import Loading from "./Loading";
import LoginPhone from "./LoginPhone";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import TeamPage from "../pages/TeamPage";
import AvatarPage from "../pages/AvatarPage";
import AdminPage from "../pages/AdminPage";
import Callback from "../pages/callback";
import Loginmyu from "./Loginmyu";
import Login from "./LoginUser";
// import LoginPhone from "./LoginPhone";

function Router() {
  const state = useContext(GlobalState);
  const [islogged] = state.isAuthenticated;
  const [isAdmin] = state.isAdmin;
  const [checked, setChecked] = useState(false);
  const [minHeight, setMinHeight] = useState("100vh");

  useEffect(() => {
    const updateHeight = () => {
      const footerHeight = footerRef.current?.offsetHeight || 0;
      setMinHeight(`calc(100vh - ${footerHeight}px)`);
    };

    updateHeight(); // tính lần đầu
    window.addEventListener("resize", updateHeight); // tính lại khi resize

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  // const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const isLogged =
      sessionStorage.getItem("islogged") === "true" ||
      localStorage.getItem("islogged") === "true";
    const phone =
      sessionStorage.getItem("phoneNumber") ||
      localStorage.getItem("phoneNumber");
    const mail = sessionStorage.getItem("mail");

    // Tự động khôi phục sessionStorage nếu đã đăng nhập ở localStorage
    if (isLogged && phone) {
      if (!sessionStorage.getItem("phoneNumber")) {
        sessionStorage.setItem("phoneNumber", phone);
      }
      if (sessionStorage.getItem("islogged") !== "true") {
        sessionStorage.setItem("islogged", "true");
      }
    }

    setChecked(isLogged && (Boolean(phone) || Boolean(mail)));
  }, [islogged]);

  const footerRef = useRef(null);

  return (
    <div className="flex flex-col min-h-screen font-sans ">
      <div style={{ minHeight }} className={`flex-1`}>
        <Routes>
          {/* ✅ Route công khai, không cần đăng nhập */}
          <Route path="/" element={<RedirectBasedOnLogin />} />
          <Route path="/myu" element={<Loginmyu />} />
          <Route path="/phone" element={<LoginPhone />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/avatar" element={<AvatarPage />} />
          <Route path="/user/avatar" element={<AvatarPage />} />

          {/* ✅ Route cần đăng nhập */}
          {checked ? (
            <>
              {/* Route cho user */}
              <Route path="user/">
                <Route path="events/" element={<Events />} />
                <Route path="teams/:name" element={<TeamPage />} />
              </Route>
              <Route path="admin/" element={<AdminPage />} />
              <Route path="*" element={<Navigate to="/user/events/" />} />
            </>
          ) : (
            <>
              {/* Hiển thị màn hình đăng nhập cho các trang yêu cầu đăng nhập khi chưa đăng nhập */}
              <Route path="*" element={<LoginPhone />} />
            </>
          )}
        </Routes>
      </div>
      <div ref={footerRef} className={` w-full`}>
        <Footer></Footer>
      </div>
    </div>
  );
}
const RedirectBasedOnLogin = () => {
  const isLogged =
    sessionStorage.getItem("islogged") === "true" ||
    localStorage.getItem("islogged") === "true";
  return isLogged ? <Navigate to="/user/events/" /> : <LoginPhone />;
};
export default Router;
